import { Progress } from '@base-ui/react/progress';

export type ProgressBarVariant = 'in-progress' | 'success' | 'failed';

interface ProgressBarProps {
  value: number; // 0-100
  variant?: ProgressBarVariant;
  className?: string;
}

const variantClasses: Record<ProgressBarVariant, string> = {
  'in-progress': 'bg-secondary-blue',
  success: 'bg-green-600',
  failed: 'bg-misc-error'
};

const ProgressBar: React.FC<ProgressBarProps> = ({ value, variant = 'in-progress', className = '' }) => (
  <Progress.Root value={value} className={`w-full ${className}`}>
    <Progress.Track className="w-full h-2 bg-bluegray-100 rounded-full overflow-hidden">
      <Progress.Indicator className={`h-full transition-all duration-300 ${variantClasses[variant]}`} />
    </Progress.Track>
  </Progress.Root>
);

export default ProgressBar;
